import styled from "styled-components";

interface DataGridCellBaseProps<TCellProps = any> {
  row: TCellProps;
  onlyRender: boolean;
}

export const StyledDataGridExpandedCell = styled('div')<DataGridCellBaseProps>`
  padding-left: ${(props: DataGridCellBaseProps) => props.onlyRender ? 0 : props.row.depth * 2}rem;
  font-weight: ${(props: DataGridCellBaseProps) => props.row.depth === 0 ? '600' : '400'};
  font-size: ${(props: DataGridCellBaseProps) => props.row.depth === 0 ? '16px' : '15px'};
  line-height: 28px;
  color: var(--allie-color-neutral-70);
  display: flex;
  align-items: center;
`;
